import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { IFilterModel } from '../components/split-button-filter/split-button-filter.component';

@Injectable({
  providedIn: 'root'
})
export class ButtonFilterService {

  public filterSubject: Subject<any> = new Subject();

  constructor() { }


  remove(filter: IFilterModel, position: number | null = null) {
    this.filterSubject.next(
      {
        action: "REMOVE",
        filter,
        data: filter.data[<number>position]
      }
    );
  }

  clear() {
    this.filterSubject.next(
      {
        action: "CLEAR"
      }
    );
  }
}
